import { render, staticRenderFns } from "./InspectproModuleMenu.vue?vue&type=template&id=995e5fbe"
import script from "./InspectproModuleMenu.vue?vue&type=script&lang=js"
export * from "./InspectproModuleMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports